import { DBSTypes } from "../_enums/dbsTypes.enum";

export class CriminalRecordModel {
	dbsHeld?: boolean;
	dbsHeldError?: string;
	dbsNumber?: string;
	dbsType?: DBSTypes;
	dbsNumberError?: string;
	dbsLastChecked?: string;
	dbsLastCheckedError?: string;
	dbsUpdateServiceNumber?: string;
	dbsUpdateServiceNumberError?: string;
	prohibitionCheck?: string;
	prohibitionCheckError?: string;
	overseasCheck?: string;
	overseasCheckNote?: string;
	convictedOffence?: boolean;
	convictions?: boolean;
	convictionsDescription?: string;
	convictedOffenceError?: string;
	convictionsError?: string;
	convictionsDescriptionError?: string;
	convictedOffenceDescription?: string;
	convictedOffenceDescriptionError?: string;
	registeredToUpdateService?: boolean;
	registeredToUpdateServiceError?: string;
	consentUpdateServiceChecks?: boolean;
	consentUpdateServiceChecksError?: string;
	note?: string;
	updateServiceCheckDate?: string;
	abroad?: boolean;
	abroadError?: string;
	overseasDeclarationExtended?: string;
	overseasDeclarationExtendedError?: string;
	educationalDisciplinaryProceedings?: boolean;
	educationalDisciplinaryProceedingsError?: string;
	dbsDeclarationRead?: boolean;
	dbsDeclarationReadError?: string;
	dbsComments?: string;
	overseasOffence?: boolean;
	overseasOffenceError?: string;
	overseasOffenceDescription?: string;
	overseasOffenceDescriptionError?: string;
	currentCriminalOffence?: boolean;
	currentCriminalOffenceError?: string;
	currentCriminalOffenceDescription?: string;
	currentCriminalOffenceDescriptionError?: string;
	dbsIssuedByBusiness?: boolean;
	dbsIssuedByCurrentEmployer?: boolean;
	section128Required?: boolean;
	section128Checked?: string;

	constructor(data: any = {}) {
		this.dbsHeld = data.dbsHeld !== null && data.dbsHeld !== undefined ? data.dbsHeld : null;
		this.dbsNumber = data.dbsNumber || "";
		this.dbsType = data.dbsType || null;
		this.dbsLastChecked = data.dbsLastChecked || "";
		this.dbsUpdateServiceNumber = data.dbsUpdateServiceNumber || "";
		this.prohibitionCheck = data.prohibitionCheck || "";
		this.overseasCheck = data.overseasCheck || null;
		this.overseasCheckNote = data.overseasCheckNote || null;
		this.convictedOffence = data.convictedOffence !== null && data.convictedOffence !== undefined ? data.convictedOffence : null;
		this.convictedOffenceDescription = data.convictedOffenceDescription || "";
		this.convictions = data.convictions !== null && data.convictions !== undefined ? data.convictions : null;
		this.convictionsDescription = data.convictionsDescription || "";
		this.registeredToUpdateService = data.registeredToUpdateService !== null && data.registeredToUpdateService !== undefined ? data.registeredToUpdateService : null;
		this.consentUpdateServiceChecks = data.consentUpdateServiceChecks !== null && data.consentUpdateServiceChecks !== undefined ? data.consentUpdateServiceChecks : null;
		this.note = data.note || "";
		this.updateServiceCheckDate = data.updateServiceCheckDate || "";
		this.abroad = data.abroad !== null && data.abroad !== undefined ? data.abroad : null;
		this.educationalDisciplinaryProceedings =
			data.educationalDisciplinaryProceedings !== null && data.educationalDisciplinaryProceedings !== undefined ? data.educationalDisciplinaryProceedings : null;
		this.overseasDeclarationExtended = data.overseasDeclarationExtended || "";
		this.dbsDeclarationRead = data.dbsDeclarationRead !== null && data.dbsDeclarationRead !== undefined ? data.dbsDeclarationRead : null;
		this.dbsComments = data.dbsComments || null;
		this.overseasOffence = data.overseasOffence !== null && data.overseasOffence !== undefined ? data.overseasOffence : null;
		this.overseasOffenceDescription = data.overseasOffenceDescription || "";
		this.currentCriminalOffence = data.currentCriminalOffence !== null && data.currentCriminalOffence !== undefined ? data.currentCriminalOffence : null;
		this.currentCriminalOffenceDescription = data.currentCriminalOffenceDescription || "";
		this.dbsIssuedByBusiness = data.dbsIssuedByBusiness !== null && data.dbsIssuedByBusiness !== undefined ? data.dbsIssuedByBusiness : null;
		this.dbsIssuedByCurrentEmployer = data.dbsIssuedByCurrentEmployer !== null && data.dbsIssuedByCurrentEmployer !== undefined ? data.dbsIssuedByCurrentEmployer : null;
		this.section128Required = data.section128Required !== null && data.section128Required !== undefined ? data.section128Required : null;
		this.section128Checked = data.section128Checked || "";
	}
}
